<template>
  <!-- 子账号 -->

  <div class="opage">
    <div>
      <!-- 子账户 -->
      <baseBreadcrumb :page="$t('message.subAccounts')" :menu="$t('message.userInfo')"></baseBreadcrumb>
      <!-- 搜索 -->
      <div class="body">
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!-- 登录名 -->
            <li>{{ $t('message.login') }}</li>
            <!-- 氏名 -->
            <li>{{ $t('message.clanName') }}</li>
            <!-- 员工编号 -->
            <li>{{ $t('message.employeeNumber') }}</li>
            <!-- 职称 -->
            <li>{{ $t('message.jobTitle') }}</li>
            <!-- 手机号 -->
            <li class="flex15">{{ $t('message.phoneNumber') }}</li>
            <!-- 邮箱 -->
            <li>{{ $t('message.mailbox') }}</li>
            <!-- 備考 -->
            <li>{{ $t('message.prepareForTheExam') }}</li>
            <!-- 对应人员 -->
            <li>{{ $t('message.correspondingPersonnel') }}</li>
            <!-- 状态 -->
            <li>{{ $t('message.status') }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">{{ index + 1 }}</li>
            <!-- 登录名 -->
            <li>{{ item.children_username }}</li>
            <!-- 氏名 -->
            <li>{{ item.children_realname }}</li>
            <!-- 员工编号 -->
            <li>{{ item.children_user_id }}</li>
            <!-- 职称 -->
            <!-- 2023/2/23 14:28 大榭说需要问问小何,等小何回来再说,先空着 -->
            <li>{{ item.jobTitle }}</li>
            <!-- 手机号 -->
            <li class="flex15">{{ item.children_mobile }}</li>
            <!-- 邮箱 -->
            <li>{{ item.children_email }}</li>
            <!-- 備考 -->
            <li>{{ item.client_remark }}</li>

            <!-- 对应人员 -->
            <li>
              <div class="realname">
                <el-button type="primary" class="primary" size="mini" @click="setItem(item)">设置</el-button>
                <p>业务：{{ item.y_admin_realname }}</p>
                <p>采购：{{ item.g_admin_realname }}</p>
                <p>配货：{{ item.p_admin_realname }}</p>
              </div>

            </li>
            <!-- 状态 -->
            <li>{{ item.children_status_name }}</li>
          </ul>
          <!-- 暂无数据 -->
          <div v-if="tableData == false" class="No_data">{{ $t('message.noDataYet') }}</div>
        </div>
        <!-- 分页 -->
        <div class="paginationContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="datas.page" :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 对应人员调整 -->
      <el-dialog title="选择人员" :close-on-click-modal="false" :visible.sync="dialogVisible" width="400px" center>
        <div class="allot">
          {{ $t('message.salesman') }}：
          <el-select v-model="allotVal.y_id" filterable :placeholder="$t('message.salesman')">
            <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="allot">
          {{ $t('message.distributionMember') }}：
          <el-select v-model="allotVal.p_id" filterable :placeholder="$t('message.distributionMember')">
            <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="allot">
          {{ $t('message.buyer') }}：
          <el-select v-model="allotVal.g_id" filterable :placeholder="$t('message.buyer')">
            <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">
            {{ $t("message.cancel") }}
          </el-button>
          <el-button type="primary" @click="setChildAccountAdmin">
            {{ $t("message.save") }}
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      num: 0,
      datas: {
        user_id: this.$route.query.userID,
      },
      tableData: [],
      total: 0,
      checked: false,
      checkNum: 0, // 已选商品番数
      chioseIdArr: [],
      billType: [],
      billMethod: [],
      dialogVisible: false,
      allotVal: {
        y_id: '',
        g_id: '',
        p_id: '',
      },
    };
  },
  component: {},
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },

  },
  created() {
    this.childAccounts();
  },
  methods: {
    // 重置
    reset() {
      this.datas = {
        user_id: this.$route.query.userID,
      };
      this.childAccounts();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.childAccounts();
    },
    // 获取配送单列表
    childAccounts() {
      this.$api.clienteleApi.childAccounts(this.datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.tableData = res.data;
        this.total = res.data.length;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.childAccounts();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.childAccounts();
    },
    //设置
    setItem(item) {
      this.allotVal = {
        y_id: item.y_id,
        g_id: item.g_id,
        p_id: item.p_id,
        child_id: item.id
      }
      this.dialogVisible = true
    },
    // 子账号设置管理员
    async setChildAccountAdmin() {
      let data = {
        child_id: this.allotVal.child_id,
        column: 'y_id',
        value: this.allotVal.y_id
      }
      let data1 = {
        child_id: this.allotVal.child_id,
        column: 'p_id',
        value: this.allotVal.p_id
      }
      let data2 = {
        child_id: this.allotVal.child_id,
        column: 'g_id',
        value: this.allotVal.g_id
      }
      await this.$api.clienteleApi.setChildAccountAdmin(data)
      await this.$api.clienteleApi.setChildAccountAdmin(data1)
      await this.$api.clienteleApi.setChildAccountAdmin(data2)
      this.childAccounts();
      this.dialogVisible = false

    },
  },
};
</script>
<style lang='scss' scoped>
.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.flex05 {
  flex: 0.5;
}

.flex15 {
  flex: 1.5;
}

.flex2 {
  flex: 2;
}

.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.table {
  font-size: 14px;

  .realname {
    position: relative;
    width: 100%;

    .primary {
      position: absolute;
      top: -28px;
      right: 0;
    }
  }

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;
  }

  .flex15 {
    flex: 1.5;
  }


  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;
    height: 100px;

    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }
}

.allot {
  width: 100%;
  margin-top: 20px;
  display: flex;
  line-height: 40px;

  /deep/.el-select {
    width: 80%;
  }
}
</style>
